var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDocumentPlaceholderIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.5 21.5h17V24h-17v-2.5zm0 6h17V30h-17v-2.5zM24 3H9.5C7.575 3 6 4.53 6 6.4v27.2C6 35.47 7.558 37 9.482 37H30.5c1.925 0 3.5-1.53 3.5-3.4V13L24 3zm6.5 32h-21A1.5 1.5 0 0 1 8 33.5v-27A1.5 1.5 0 0 1 9.5 5H23v6a3 3 0 0 0 3 3h6v19.5a1.5 1.5 0 0 1-1.5 1.5z",
  fill: "#0481A0"
}))));
export default SvgDocumentPlaceholderIcon;